import { render, staticRenderFns } from "./VisualEffectOfTargets.vue?vue&type=template&id=6c45f8d2&scoped=true&"
import script from "./VisualEffectOfTargets.vue?vue&type=script&lang=js&"
export * from "./VisualEffectOfTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45f8d2",
  null
  
)

export default component.exports